import { getSystemParam } from '../platform';
import { isAvailable } from 'jssdk/utils';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * language.getClientLanguage
 *
 * [PLATFORM]
 * mac        5.17.0+
 * windows    5.17.0+
 * linux      5.17.0+
 * ios        5.17.0+
 * android    5.17.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/

export async function getClientLanguage() {
  try {
    await isAvailable('language.getClientLanguage');
    const param = await getSystemParam();
    return param.globalLang;
  } catch (e) {
    console.warn('getSystemParam failed, fallback to navigator', navigator, e);
    return (window as any)._zm_lang || navigator.language;
  }
}
export default {
  getClientLanguage,
};
